import { connectFunctionsEmulator, getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebase/firebase';

let emulatorConnected = false;

function getPracticalReadingFunctions() {
  const functions = getFunctions(app, 'us-central1');
  const isLocalBrowser =
    typeof window !== 'undefined' &&
    ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
  const shouldUseEmulator =
    process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === 'true' && isLocalBrowser;

  if (shouldUseEmulator && !emulatorConnected) {
    const host = process.env.REACT_APP_FUNCTIONS_EMULATOR_HOST || '127.0.0.1';
    const port = Number(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || '5001');
    connectFunctionsEmulator(functions, host, port);
    emulatorConnected = true;
  }

  return functions;
}

function extractFunctionsMessage(error, fallbackMessage) {
  const details = typeof error?.details === 'string' ? error.details : '';
  const message = typeof error?.message === 'string' ? error.message : '';
  return details || message || fallbackMessage;
}

function buildFunctionsError(error, fallbackMessage) {
  const nextError = new Error(extractFunctionsMessage(error, fallbackMessage));
  nextError.code = error?.code || '';
  nextError.details = error?.details;
  return nextError;
}

export async function signInWithPracticalReadingAccess({ email, password }) {
  try {
    const functions = getPracticalReadingFunctions();
    const callable = httpsCallable(functions, 'signInWithPracticalReading');
    const result = await callable({ email, password });
    return result?.data || {};
  } catch (error) {
    throw buildFunctionsError(
      error,
      'No se pudo validar el acceso con Ejercicios Prácticos.'
    );
  }
}

export async function getPracticalReadingPendingAccessList() {
  try {
    const functions = getPracticalReadingFunctions();
    const callable = httpsCallable(functions, 'getPracticalReadingPendingAccess');
    const result = await callable({});
    return result?.data?.pendingItems || [];
  } catch (error) {
    throw buildFunctionsError(
      error,
      'No se pudieron cargar los accesos pendientes.'
    );
  }
}

export async function approvePracticalReadingPendingAccess(payload) {
  try {
    const functions = getPracticalReadingFunctions();
    const callable = httpsCallable(functions, 'approvePracticalReadingPendingAccess');
    const result = await callable(payload);
    return result?.data || {};
  } catch (error) {
    throw buildFunctionsError(
      error,
      'No se pudo aprobar el acceso pendiente.'
    );
  }
}

export async function rejectPracticalReadingPendingAccess(pendingId) {
  try {
    const functions = getPracticalReadingFunctions();
    const callable = httpsCallable(functions, 'rejectPracticalReadingPendingAccess');
    const result = await callable({ pendingId });
    return result?.data || {};
  } catch (error) {
    throw buildFunctionsError(
      error,
      'No se pudo rechazar el acceso pendiente.'
    );
  }
}
